import errors from "./errors";
export default {
    init() {
        this.getUser();
        this.updateUser();
    },
    getUser() {
        $('body').on('keyup', '#phone_last_digits', function () {

            let phoneNumber = $('#phone_last_digits').val();

            if(phoneNumber.length >= 4) {

                $.ajax({
                    type: 'post',
                    url: '/admin/digits_search',
                    data: ({
                        last_digits: phoneNumber
                    }),
                    success: function (response) {
                        $('#response-dropdown').empty();
                        $('#response-dropdown').html(response);
                        $('#phone_last_digits').dropdown('show');
                    },
                });
            }

            $('#phone_last_digits').blur(function() {
                setTimeout(() => {
                    $('#phone_last_digits').dropdown('hide');
                }, 200);
            });
        });
    },
    updateUser() {
        $('body').on('click', '.user-info-submit-form', function(event) {
            event.preventDefault();
            $('.alert').addClass('d-none')
                        .removeClass('alert-danger')
                        .removeClass('alert-success')
                        .text('');
            if($('.user-info-edit-phone').val().length < 12) {
                $('#label-phone-alert').css('display','block');
            } else {
                let form = $(this).closest('form')[0];
                let data = new FormData(form);
                $.ajax({
                    type: 'POST',
                    url: '/admin/user_info_update',
                    data: data,
                    processData: false,
                    contentType: false,
                    success: function (response) {
                        if(response.success) {
                            $('.alert')
                                .removeClass('d-none')
                                .removeClass('alert-danger')
                                .addClass('alert-success')
                                .text(response.message);
                        }
                        setTimeout(() => {
                            $('.modal').modal('hide');
                        }, 1500);
                    },
                    error: function (response) {
                        $('.alert')
                            .removeClass('d-none')
                            .removeClass('alert-success')
                            .addClass('alert-danger');
                        let alert_text = '<ul>';
                        $.each(response.responseJSON.errors, function (index, value) {
                            alert_text += '<li>' + value + '</li>';
                        });
                        $('.alert').html(alert_text+'</ul>');
                    }
                });
            }
        });
    },
}
